import { Component, ElementRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgBsToastService } from "ng-bs-toast-service";
import { HttpErrorResponse } from "@angular/common/http";
import { Breadcrumb } from "../../../shared/components";
import { LibraryService } from "../library.service";

@Component({
    selector: "app-form-book",
    standalone: false,
    templateUrl: "./form-book.component.html",
})
export class FormBookComponent {
    constructor(
        private libraryService: LibraryService,
        private router: Router,
        private toastService: NgBsToastService,
    ) {}

    loading = { save: false };

    breadcrumb: Breadcrumb[] = [
        { title: "Livros", route: ["/configurations"], queryParams: { tab: "biblioteca" } },
        { title: "Novo livro" },
    ];

    title = "Novo Livro";

    readonly maxFileSizeMb = 200;

    selectedFile: File | null = null;
    isDragging = false;

    @ViewChild("fileInput") fileInput: ElementRef<HTMLInputElement>;

    onFileChange(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
            this.setFile(input.files[0]);
        }
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;

        const file = event.dataTransfer?.files[0];
        if (!file) return;

        this.setFile(file);
    }

    openFileInput() {
        this.fileInput.nativeElement.click();
    }

    removeFile() {
        this.selectedFile = null;
        if (this.fileInput) {
            this.fileInput.nativeElement.value = "";
        }
    }

    private setFile(file: File) {
        if (file.type !== "application/pdf") {
            this.toastService.send("Arquivo inválido", "Apenas arquivos PDF são permitidos.", "danger");
            this.removeFile();
            return;
        }

        if (file.size > this.maxFileSizeMb * 1024 * 1024) {
            this.toastService.send("Arquivo muito grande", `O livro excede o limite de ${this.maxFileSizeMb} MB e não pode ser enviado.`, "danger");
            this.removeFile();
            return;
        }

        this.selectedFile = file;
    }

    saveBook() {
        if (!this.selectedFile) return;

        this.loading.save = true;

        const formData = new FormData();
        formData.append("file", this.selectedFile);
        formData.append("title", this.selectedFile.name.replace(/\.pdf$/i, "").trim());
        formData.append("size_mb", (this.selectedFile.size / (1024 * 1024)).toFixed(2));

        this.libraryService
            .create(formData)
            .subscribe({
                next: () => {
                    this.router.navigate(["/configurations"], { queryParams: { tab: "biblioteca" } });
                    this.toastService.send("Sucesso", "Livro cadastrado com sucesso!", "success");
                },
                error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, "danger"),
            })
            .add(() => (this.loading.save = false));
    }
}
